export function indexCategories (search)
{
    return axios.get(route('api.manage.companies.vdab.categories') + '?search=' + search)
    .then(response => {
        return response.data;
    });
}

export function showCategory (categoryId)
{
    return axios.get(route('api.manage.companies.vdab.categories.show', { categoryId: categoryId}))
        .then(response => response.data);
}

export function indexStudies (search = null, parent = null, searchInAll = null)
{
    let query = route('api.manage.companies.vdab.studies');
    let mark = '?';
    let and = '';

    if (search) {
        query += mark + and + 'search=' + search;
        mark = '';
        and = '&';
    }

    if (parent) {
        query += mark + and + 'parent=' + parent;
        mark = '';
        and = '&';
    }

    if (searchInAll) {
        query += mark + and + 'global=' + searchInAll;
        mark = '';
        and = '&';
    }

    return axios.get(query).then(response => {
        return response.data;
    })
}

export function requestIntegration (userId){
    return axios.post(route('api.manage.companies.vdab.integration', { userId: userId}))
        .then(response => response.data);
}

export function cancelIntegration(cancel = true) {
    return axios.post(route('api.manage.companies.vdab.integration.cancel'), { cancel })
        .then(response => response.data);
}
